<template>

    <ErrorSummary :response-status="responseStatus"/>

    <RadioGroup v-model="isMessagingEnabled" @update:modelValue="_ => updateProfileMessagingSettings()">
        <RadioGroupLabel class="text-lg font-medium text-gray-900">Enable Messaging?</RadioGroupLabel>

        <SkeletonCard  class="mt-4" v-if="isFetching" card-style="long" :num-of-cards=2 />
        
        <div v-else class="grid grid-cols-1 mt-4 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
            <RadioGroupOption as="template"
                              v-for="setting in messagingSettingOptions"
                              :key="setting.value"
                              :value="setting.value" v-slot="{ checked, active }">
                <div :class="[checked ? 'border-transparent' : 'border-clay-500', active ? 'ring-2 ring-clay-500 bg-clay-50' : '', 'relative flex cursor-pointer rounded-lg border  p-4 shadow-sm focus:outline-hidden']">
                                                    <span class="flex flex-1">
                                                      <span class="flex flex-col">
                                                        <RadioGroupLabel as="span" class="block text-sm font-medium text-gray-900">{{ setting.name }}</RadioGroupLabel>
                                                        <RadioGroupDescription as="span" class="flex items-center mt-1 text-sm text-clay-800">{{ setting.description }}</RadioGroupDescription>
                                                      </span>
                                                    </span>
                    <CheckCircleIcon v-if="checked" class="w-5 h-5 text-clay-600" aria-hidden="true" />
                    <span :class="[active ? 'border' : 'border-2', checked ? 'border-clay-500' : 'border-transparent', 'pointer-events-none absolute -inset-px rounded-lg']" aria-hidden="true" />
                </div>
            </RadioGroupOption>
        </div>
    </RadioGroup>

    <NotificationSuccess :show="updateSuccessful" content="Your changes were successfully saved."
                         title="Successfully saved!"/>

</template>

<script lang="ts" setup>
// @ts-ignore
import {defineProps, onMounted, Ref, ref} from "vue";
import {client, trackEvent} from '@/shared';
import { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue';
import { CheckCircleIcon } from '@heroicons/vue/20/solid';
import {
    GetProfileMessaging, GetProfileMessagingResponse,UpdateProfileMessaging
} from "@/dtos";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";

onMounted(async () => {
    await getProfileMessagingSettings();
});

const messagingSettingOptions = ref([
    { name: "Yes", description: "Allow other StageAgent members to message you with a request to start an email conversation.",  value: true},
    { name: "No", description: "Do not allow other StageAgent members to message you directly.", value: false}
]);

const isFetching = ref(true);

const isMessagingEnabled = ref("");
const getProfileMessagingSettings = async () => {
    await client.get<GetProfileMessagingResponse>(new GetProfileMessaging())
        .then(response => {
            isMessagingEnabled.value = response.isMessagingEnabled;
            isFetching.value = false;
        });
}

const updateSuccessful: Ref<Boolean> = ref(false);
const responseStatus = ref(null);

const updateProfileMessagingSettings = async () => {
    updateSuccessful.value = false;
    await client.post(new UpdateProfileMessaging({
        enableMessaging : isMessagingEnabled.value
    }))
        .then(() => {
            updateSuccessful.value = true;
            responseStatus.value = null;

            trackEvent( 'profile_updated', {
                method: 'messaging',
                enabled: isMessagingEnabled.value
            });
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
};

</script>